import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { configGoogle } from "utils/services";
import { is_prod } from "utils/checker";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, extendTheme, type ThemeConfig  } from '@chakra-ui/react'
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "store";
import { NuqsAdapter } from 'nuqs/adapters/react'

// AG Grid module registration
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

localStorage.setItem('chakra-ui-color-mode', 'light');

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (is_prod) {
  configGoogle();
  console.log = function () {};
}

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  
}

const theme = extendTheme({
  config,
  components: {
    Popover: {
      baseStyle: {
        content: {
          zIndex: 9999, // Adjust as needed
        },
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
          <ChakraProvider theme={theme}>
            <Provider store={store}>
              <NuqsAdapter>
                <App />
              </NuqsAdapter>
            </Provider>
          </ChakraProvider>
      </Router>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
